export interface BarProps {
  section?: 'negative' | 'positive';
  value?: number;
  color?: string;
}

export function getBarStyle(props: BarProps): React.CSSProperties {
  const { section = 'positive', value = 0, color = '#666' } = props;
  const isNegativeValue = value < 0;
  const absolutePercentValue = Math.min(100, Math.abs(Math.round(value * 10000) / 100));
  const visibleForSection = value < 0 ? 'negative' : 'positive';
  const val = Math.abs(Math.round(value * 10000) / 100);

  const hideBar = (section === 'negative' && !isNegativeValue) || (section === 'positive' && isNegativeValue);

  const showOverflow = val > 100 && section === visibleForSection;

  return {
    ['--bar-before-display' as string]: hideBar ? 'none' : 'block',
    ['--bar-before-width' as string]: hideBar ? '0' : `${absolutePercentValue}%`,
    ['--bar-color' as string]: color,
    ['--bar-after-left' as string]: showOverflow && section === 'negative' ? '0' : undefined,
    ['--bar-after-right' as string]: showOverflow && section === 'positive' ? '0' : undefined,
    ['--bar-after-gradient' as string]: showOverflow
      ? section === 'negative'
        ? 'linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)'
        : 'linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)'
      : 'none',
  };
}
